<template>
  <div class="mt-3 temporaryCustom">
    <v-col cols="12" class="pa-0">
      <DatePickerInput
        :placeholder="$gettext('Select days')"
        v-model="selectedDay"
        :min="new Date().toISOString().slice(0, 10)"
        :multiple="true"
      />
    </v-col>

    <div v-if="timeTemporary.length !== 0">
      <v-row no-gutters v-for="(day, idx) in timeTemporary" :key="idx" class="mb-3">
        <v-col cols="4">
          <Checkbox
            v-model="day.checked"
            :key="day.date"
            :label="$dayjs(day.date).format('DD/MM/YYYY')"
            @input="remove(idx)"
          />
        </v-col>
        <v-col cols="4">
          <Time
           class="mr-4"
            v-model="day.timeFrom"
            @input="changeText(idx, 'timeFrom', day.timeFrom)"
          />
        </v-col>
        <v-col cols="4">
          <Time
            v-model="day.timeTo"
            @input="changeText(idx, 'timeto', day.timeTo)"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import DatePickerInput from "@/components/Common/DatePickerInput";
import Time from "@/components/Forms/Time";
import Checkbox from "@/components/Forms/Checkbox";
export default {
  name: "TimeTemporary",
  components: {
    DatePickerInput,
    Time,
    Checkbox,
  },
  props: {
    value: { type: Array, default: []},
  },
  data() {
    return {
      timeTemporary: [],
      selectedDay: [],
    };
  },
  computed: {
  },
  methods: {
    remove(idx){
      this.timeTemporary.splice(idx, 1);
      this.selectedDay.splice(idx, 1)
    },
    changeText(idx, name, value) {
      this.timeTemporary[idx][name] = value
      const entity = this.formatTemporary(this.timeTemporary)
      this.$emit('input', entity)
    },
    formatDateTime(item) {
      let dateFormat = {}
      item.forEach((element, idx) => {
        switch(idx) {
          case 0:
            dateFormat.date = element
            this.selectedDay.push(element)
          case 1:
            dateFormat.timeFrom = element
          case 2:
            dateFormat.timeTo = element
          case 3:
            dateFormat.sectionDay = element
            dateFormat.checked = true
        }
      });
      return dateFormat
    },
    addNewDateTime(data) {
      const {date, timeFrom, timeTo,  sectionDay, checked} = data
      let item = {}
      item.date = date,
      item.timeFrom = timeFrom || '00:00',
      item.timeTo = timeTo || '23:59',
      item.sectionDay = this.$dayjs(date).day() ,
      item.checked = checked || true
      return item
    },
    formatTemporary(data) {
      let listResult = []
      if(data && data.length !== 0) {
        data.map(item => {
          listResult.push(Object.values(item))
        })
      }
      listResult.forEach(item => item.pop())
      return listResult
    }
  },
  watch: {
    selectedDay: {
      handler(val) {
        let newElement = null
        let arrDayFromTemporary = this.timeTemporary.map(element => element.date);
        val.forEach(item => {
          let check = arrDayFromTemporary.includes(item)
          newElement = check ? null : item
        })
        if(newElement) {
          const day = this.addNewDateTime({date: newElement})
          this.timeTemporary.push(day)
        } else if(this.timeTemporary.length > val.length) {
          this.timeTemporary.forEach((item, index, object) => {
            let check = val.includes(item.date)
            if(!check) {
              object.splice(index, 1);
            }
          })
        }
      }
    },
    timeTemporary: {
      handler(val) {
        const entity = this.formatTemporary(val)
        this.$emit('input', entity)
      }
    }
  },
  mounted () {
    const list = JSON.parse(JSON.stringify(this.value))
    list.map(item => {
      const dateFormat = this.formatDateTime(item)
      this.timeTemporary.push(dateFormat)
    });
  },
};
</script>
